import { APP_ROUTES } from '@zorro/common-utils';
import { Breadcrumbs } from '@zorro/design-system/v2/Breadcrumbs';

const getBreadcrumbsItems = () => [
  {
    title: 'Enrollment management',
    href: APP_ROUTES.OPS_ENROLLMENT_MANAGEMENT(),
  },
  {
    title: 'Bulk application',
    href: APP_ROUTES.OPS_BULK_CARRIER_APPLICATION_ENROLLMENT_INFO(),
  },
];

export const BulkApplicationBreadcrumbs = () => {
  return <Breadcrumbs items={getBreadcrumbsItems()} my="2rem" />;
};
